<template>
  <div class="super-admin-container">
    <!-- Header -->
    <div class="header">
      <h1>Super Admin Dashboard</h1>
      <div class="header-actions">
        <button @click="" class="export-btn">
          📊 Export
        </button>
      </div>
    </div>
      <DataTable
      :customers="customerList"
      :loading="loading"
      :selectedTenant="selectedTenant"
      :totalRecords="totalRecords"
      :pageSize="pageSize"
      :page="page"
      @pagechange="handlePageChange"
    />
    </div>  
</template>


<script setup lang="ts">
import { ref, watch, computed, onMounted } from 'vue';
import GripLink from '@/components/GripLink.vue';
import { useCustomerListLoader } from '@/composables/useCustomerListLoader';
import type { AdminCustomerResponseDTO } from '@/models/Customers/AdminResponseDTO';


import { supabase } from '@/supabase';


const noArgs = ref([])

import DataTable from './DataTable.vue';
const remote_procedure_call : string = 'rooftop_unique_customers_admin_6';

const error = ref<string | null>(null);
//const loading = ref(false);
import formatTime from '@/utils/formatTime';

function handlePageChange({ page: newPage }: { page: number }) {
  page.value = newPage
  console.log('Page changed to:', newPage)
  //getCustomers({ page: page.value, pageSize: pageSize.value })
}
import { useUserStore } from '@/store';
const userStore = useUserStore(); 
  onMounted(() => {
    if (userStore.user.value) {
      getCustomers()
    } else {
      const stop = watch(userStore.user, (val:any) => {
        if (val) {
          getCustomers()
          stop()
        }
      })
    }
  })

const selectedTenant = ref(userStore.getRooftopId)
const {
  customerList,
  loading,
  getCustomers
} = useCustomerListLoader<AdminCustomerResponseDTO>(
  (repo) => repo.getSuperAdminCustomers(),
  noArgs,
  selectedTenant
)
const firstNameSort = ref({toggle: false, order: 'asc'});
const lastNameSort = ref({toggle: false, order: 'asc'});
const dateSort = ref({toggle: false, order: 'asc'});
const engagementSort = ref({toggle: false, order: 'asc'});
const equitySort = ref(false);
const approvalSort = ref(false);
const viewedSort = ref(false);
const vehicleSort = ref(false);
const valuationSort = ref(false);
const balanceSort = ref({toggle: false, order: 'asc'});
const paymentSort = ref(false);

const showCustomerSortMenu = ref(false);
const customers = ref<any[]>([]);
const handleCustomerClick = (customer: any) => {
  console.log('Navigating to customer:', customer.id);
};

 interface RPCTypedefCustomer {
  id: number;
  created_at: string;
  first_name: string;
  last_name: string;
  vin: string | null;
  phone: string | null;
  email: string | null;
  plate: string | null;
  city: string | null;
  state: string | null;
  mileage: string | null;
  address: string | null;
  zip: string | null;
  vehicle_data_status: string | null;
  fts: string | null;
  status: boolean | null;
  appt_id: string | null;
  rooftop_id: string;
  appt_time: string | null; // Format: "HH:mm:ss"
  appt_date: string | null; // Format: "YYYY-MM-DD"
  engaged: boolean | null;
  deal_status: string | null;
  FB_lead: boolean | null;
  customer_notes: string | null;
  DV_customer_number: string | null;
  opt_in: boolean | null;
  reviewed: boolean | null;
  opt_in_checked: boolean | null;
  opted_in_at: string | null;
  opt_in_text_sent_at: string | null;
  checked_in_at: string | null;
  reviewed_at: string | null;
  last_viewed_at: string | null;
  last_viewed_by: string | null; // UUID as string
  score: number | null;
  credit_score: number | null;
}

interface EnhancedCustomer {
  id: number;
  created_at: string;
  first_name: string;
  last_name: string;
  vin: string | null;
  phone: string | null;
  email: string | null;
  plate: string | null;
  city: string | null;
  state: string | null;
  mileage: string | null;
  address: string | null;
  zip: string | null;
  vehicle_data_status: string | null;
  fts: string | null;
  status: boolean | null;
  appt_id: string | null;
  rooftop_id: string;
  appt_time: string | null;
  appt_date: string | null;
  engaged: boolean | null;
  deal_status: string | null;
  fb_lead: boolean | null;
  customer_notes: string | null;
  dv_customer_number: string | null;
  opt_in: boolean | null;
  reviewed: boolean | null;
  opt_in_checked: boolean | null;
  opted_in_at: string | null;
  opt_in_text_sent_at: string | null;
  checked_in_at: string | null;
  reviewed_at: string | null;
  last_viewed_at: string | null;
  last_viewed_by: string | null;
  score: number | null;
  credit_score: number | null;
  // Additional joined fields
  credit_freeze: boolean | null;
  loan_balance: number | null;
  payment: number | null;
  acct_type: string | null;
  vehicle_year: number | null;
  vehicle_make: string | null;
  vehicle_model: string | null;
  vehicle_vin: string | null;
  vehicle_value: number | null;
  equity_score: number | null;
}
const groupByCustomerId = (dataArray: any[]) => {
  return dataArray.reduce((acc, item) => {
    if (!acc[item.customer_id]) {
      acc[item.customer_id] = [];
    }
    acc[item.customer_id].push(item);
    return acc;
  }, {});
};

const headers = [
    'First Name',
    'Last Name',
    'Phone Number',
    'Appointment Date',
    'Appointment Time',
    'Engaged',
    'Deal Status',
    'Vehicle',
    'Credit Score Range',
    'Credit Freeze',
    'Loan Balance',
    'Payment',
    'Account Type',
    'Equity Score'
];

// Filter state
const filter = ref({
    startDate: null as string | null,
    endDate: null as string | null,
    engagement: 'all',
    equity: 'all'
});

// Helper to build filter params for the RPC
const buildFilterParams = () => {
    return {
        r_rooftop: userStore.getRooftopId,
        start_date: filter.value.startDate,
        end_date: filter.value.endDate,
        engagement: filter.value.engagement !== 'all' ? filter.value.engagement : null,
        equity: filter.value.equity !== 'all' ? filter.value.equity : null
    };
}


// Add page change handler
const changePage = async (newPage: number) => {
    if (newPage < 1 || newPage > totalPages.value) return;
    
    page.value = newPage;
    await reloadCustomers();
};
const reloadCustomers = async () => {
  loading.value = true;
  error.value = null;

  try {
    let query = supabase.rpc(remote_procedure_call, { r_rooftop: userStore.getRooftopId });

    // Apply sorting - now we can sort by any field returned by RPC
    if (firstNameSort.value.toggle) {
      query = query.order('first_name', { ascending: firstNameSort.value.order === 'asc' });
    } 
    else if (lastNameSort.value.toggle) {
      query = query.order('last_name', { ascending: lastNameSort.value.order === 'asc' });
    } 
    else if (balanceSort.value.toggle) {
      query = query.order('loan_balance', { ascending: balanceSort.value.order === 'asc' });
    }
    else if (dateSort.value.toggle) {
      query = query.order('appt_date', { ascending: dateSort.value.order === 'asc' });
    }
    else if (engagementSort.value.toggle) {
      query = query.order('engaged', { ascending: engagementSort.value.order === 'asc' });
    }

    // Apply pagination
    const { data: rooftopCustomers, error: rpcError } = await query
      .range((page.value - 1) * pageSize.value, page.value * pageSize.value - 1);

    if (rpcError) {
      throw new Error(`RPC failed: ${rpcError.message}`);
    }

    if (!rooftopCustomers?.length) {
      customers.value = [];
      return;
    }

    // No need to fetch additional data - it's all in the RPC result!
    // Just restructure the data to match your template expectations
    customers.value = rooftopCustomers.map((customer: EnhancedCustomer) => ({
      ...customer,
      // Create nested structure for backward compatibility
      vehicles: customer.vehicle_year ? [{
        year: customer.vehicle_year,
        make: customer.vehicle_make,
        model: customer.vehicle_model,
        vin: customer.vehicle_vin
      }] : [],
      credit_info: customer.credit_score ? [{
        credit_score: customer.credit_score,
        credit_freeze: customer.credit_freeze
      }] : [],
      loan_info: customer.loan_balance ? [{
        loan_balance: customer.loan_balance,
        payment: customer.payment,
        acct_type: customer.acct_type
      }] : [],
      valuations: customer.vehicle_value ? [{
        target: customer.vehicle_value
      }] : [],
      equity_scores: customer.equity_score ? [{
        score: customer.equity_score
      }] : []
    }));

  } catch (err: any) {
    console.error('Error in reloadCustomers:', err);
    error.value = err.message || "Failed to load customers";
  } finally {
    loading.value = false;
  }
};

const initCustomers = async () => {
  try {
    // Get total count first (without pagination)
    const { data: allCustomers, error: countError } = await supabase
      .rpc(remote_procedure_call, { r_rooftop: userStore.getRooftopId });

    if (countError) {
      throw new Error(`Count RPC failed: ${countError.message}`);
    }

    totalRecords.value = allCustomers?.length || 0;

    // Load first page
    await reloadCustomers();

  } catch (err: any) {
    console.error('Error in initCustomers:', err);
    error.value = err.message || "Failed to initialize customers";
  }
};

// const initCustomers = async () => {
//     const { data: rooftopCustomers, error: rpcError } = await supabase
//         .rpc('rooftop_unique_customers', {
//       r_rooftop: 'DVD00001' 
//     })
    
//   .range((page.value - 1) * pageSize.value, page.value * pageSize.value - 1); 


//     if (rpcError) {
//         throw new Error(`RPC failed: ${rpcError.message}`);
//     }

//     if (!rooftopCustomers || rooftopCustomers.length === 0) {
//         customers.value = [];
//         return;
//     }

//     // MAP CUSTOMERS TO COLLECTION
//     customers.value = rooftopCustomers.map((customer: RPCTypedefCustomer) => ({
//         id: customer.id,
//         first_name: customer.first_name,
//         last_name: customer.last_name,
//         email: customer.email
//     }));

//     // If Supabase supports returning a count, use that; otherwise, fetch all records to count
//     const { count } = await supabase
//       .rpc('rooftop_unique_customers', { r_rooftop: 'DVD00001' }, { count: 'exact', head: true });
//     totalRecords.value = count ?? rooftopCustomers.length;
// };
const page = ref(1); // Start at page 1
const pageSize = ref(3);

const totalRecords = ref(0);
const totalPages = computed(() => {
  return Math.ceil(totalRecords.value / pageSize.value);
});

// const reloadCustomers = async () => {
//   loading.value = true;
//   error.value = null;

//   try {
//     let query = supabase.rpc('rooftop_unique_customers', { r_rooftop: 'DVD00001' });

//     // Apply sorting
//     if (firstNameSort.value.toggle) {
//       query = query.order('first_name', { ascending: firstNameSort.value.order === 'asc' });
//     } 
//     else if (lastNameSort.value.toggle) {
//       query = query.order('last_name', { ascending: lastNameSort.value.order === 'asc' });
//     } else if (balanceSort.value.toggle) {
//       query = query.order('balance', { ascending: balanceSort.value.order === 'asc' });
//     }

//     // Apply pagination
//     const { data: rooftopCustomers, error: rpcError } = await query
//       .range((page.value - 1) * pageSize.value, page.value * pageSize.value - 1);

//     if (rpcError) {
//       throw new Error(`RPC failed: ${rpcError.message}`);
//     }

//     if (!rooftopCustomers?.length) {
//       customers.value = [];
//       return;
//     }

//     const customerIds = rooftopCustomers.map((customer: RPCTypedefCustomer) => customer.id);

//     // Fetch all related data in parallel
//     const [vehiclesData, creditData, loanData, valuationsData, equityData] = await Promise.all([
//       supabase.from('vehicles').select('*').in('customer_id', customerIds),
//       supabase.from('credit_info').select('*').in('customer_id', customerIds),
//       supabase.from('loan_info').select('*').in('customer_id', customerIds),
//       supabase.from('valuations').select('*').in('customer_id', customerIds),
//       supabase.from('equity_scores').select('*').in('customer_id', customerIds)
//     ]);

//     // Group data by customer_id for efficient lookup
//     const vehiclesByCustomer = groupByCustomerId(vehiclesData.data || []);
//     const creditByCustomer = groupByCustomerId(creditData.data || []);
//     const loanByCustomer = groupByCustomerId(loanData.data || []);
//     const valuationsByCustomer = groupByCustomerId(valuationsData.data || []);
//     const equityByCustomer = groupByCustomerId(equityData.data || []);

//     // Merge all data together - THIS WAS MISSING!
//     customers.value = rooftopCustomers.map((customer: RPCTypedefCustomer) => ({
//       ...customer,
//       vehicles: vehiclesByCustomer[customer.id] || [],
//       credit_info: creditByCustomer[customer.id] || [],
//       loan_info: loanByCustomer[customer.id] || [],
//       valuations: valuationsByCustomer[customer.id] || [],
//       equity_scores: equityByCustomer[customer.id] || []
//     }));

//   } catch (err: any) {
//     console.error('Error in reloadCustomers:', err);
//     error.value = err.message || "Failed to load customers";
//   } finally {
//     loading.value = false;
//   }
// };


  const getSortIcon = (column: string) => {
    return "↓" 
  };

const toggleSort = (column: string) => {
  // Reset all sort states except the selected column
   firstNameSort.value = { toggle: false, order: 'asc' };
   lastNameSort.value = { toggle: false, order: 'asc' };
   balanceSort.value = { toggle: false, order: 'asc' };

  if (column === 'first_name') {
    if (!firstNameSort.value.toggle) {
      firstNameSort.value = { toggle: true, order: 'asc' };
    } else if (firstNameSort.value.order === 'asc') {
      firstNameSort.value = { toggle: true, order: 'desc' };
    } else {
      firstNameSort.value = { toggle: false, order: 'asc' };
    }
  } else if (column === 'last_name') {
    if (!lastNameSort.value.toggle) {
      lastNameSort.value = { toggle: true, order: 'asc' };
    } else if (lastNameSort.value.order === 'asc') {
      lastNameSort.value = { toggle: true, order: 'desc' };
    } else {
      lastNameSort.value = { toggle: false, order: 'asc' };
    }
  } else if (column === 'balance') {
    if (!balanceSort.value.toggle) {
      balanceSort.value = { toggle: true, order: 'asc' };
    } else if (balanceSort.value.order === 'asc') {
      balanceSort.value = { toggle: true, order: 'desc' };
    } else {
      balanceSort.value = { toggle: false, order: 'asc' };
    }
  }
  reloadCustomers();
};

onMounted(async () => {
    document.title = 'Super Admin';
    const res = await initCustomers();
});
</script>

<style scoped lang="css">
/* * {
    border: 1px solid red !important;
} */

.super-admin-container {
    max-width: 1200px;
    margin: 40px auto;
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.08);
    padding: 80px 28px 40px 28px; /* Increased top padding to 80px */
    font-family: 'Inter', Arial, sans-serif;
    height: auto;
}

.table-container {
    border-radius: 12px;
    overflow-x: auto;   /* Only horizontal scroll for table if needed */
    border: 1px solid #e5e7eb;
    background: #f9f9fb;
    max-width: 100%;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
}

.header h1 {
    font-size: 2rem;
    font-weight: 700;
    color: #22223b;
}

.header-actions {
    display: flex;
    gap: 12px;
}

.export-btn {
    background: #4f8cff;
    color: #fff;
    border: none;
    padding: 10px 22px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}
.export-btn:hover {
    background: #2563eb;
}

.filters {
    display: flex;
    gap: 16px;
    margin-bottom: 28px;
    align-items: center;
    flex-wrap: wrap;
}

.date-input, .filter-select {
    padding: 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    font-size: 1rem;
    background: #f9f9fb;
    color: #22223b;
    transition: border 0.2s;
}
.date-input:focus, .filter-select:focus {
    border-color: #4f8cff;
    outline: none;
}

.reset-btn {
    background: #f3f4f6;
    color: #22223b;
    border: 1px solid #e0e0e0;
    padding: 8px 18px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, border 0.2s;
}
.reset-btn:hover {
    background: #e0e7ef;
    border-color: #4f8cff;
}

.loading, .error, .no-data {
    text-align: center;
    margin: 40px 0;
    color: #6c6c80;
    font-size: 1.1rem;
}

.spinner {
    border: 4px solid #e0e0e0;
    border-top: 4px solid #4f8cff;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin: 0 auto 12px auto;
    animation: spin 1s linear infinite;
}
@keyframes spin {
    to { transform: rotate(360deg); }
}

.table-container {
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e5e7eb;
    background: #f9f9fb;
}

.table-header, .table-row {
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr 2fr 1fr 1fr 1fr;
    align-items: center;
}

.table-header {
    background: #f3f4f6;
    font-weight: 700;
    color: #22223b;
    font-size: 1rem;
    border-bottom: 1px solid #e5e7eb;
    user-select: none;
}

.header-cell {
    padding: 14px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: background 0.15s;
}
.header-cell:hover {
    background: #e0e7ef;
}
.header-cell:last-child {
    cursor: default;
}

.table-row {
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
    transition: background 0.15s;
    cursor: pointer;
}
.table-row:hover {
    background: #f3f4f6;
}

.cell {
    padding: 14px 12px;
    font-size: 0.98rem;
    color: #22223b;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.sub-text {
    color: #6c6c80;
    font-size: 0.92rem;
}

.badge {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 6px;
    font-size: 0.93rem;
    font-weight: 600;
    background: #e0e7ef;
    color: #22223b;
}

.badge-success {
    background: #d1fae5;
    color: #047857;
}
.badge-danger {
    background: #fee2e2;
    color: #b91c1c;
}
.equity-badge {
    background: #fef9c3;
    color: #b45309;
}

.no-data {
    padding: 32px 0;
    color: #6c6c80;
    font-size: 1.1rem;
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 18px;
    margin-top: 32px;
}

.page-btn {
    background: #f3f4f6;
    color: #22223b;
    border: 1px solid #e0e0e0;
    padding: 8px 18px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, border 0.2s;
}
.page-btn:disabled {
    background: #e5e7eb;
    color: #bdbdbd;
    cursor: not-allowed;
}
.page-btn:hover:not(:disabled) {
    background: #e0e7ef;
    border-color: #4f8cff;
}

.page-info {
    font-size: 1rem;
    color: #6c6c80;
}

@media (max-width: 900px) {
    .super-admin-container {
        padding: 14px 2vw 24px 2vw;
    }
    .table-header, .table-row {
        grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr 2fr 1fr 1fr 1fr;
        font-size: 0.95rem;
    }
}

@media (max-width: 700px) {
    .table-header, .table-row {
        grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr 1.5fr;
        font-size: 0.92rem;
    }
    .header-cell, .cell {
        padding: 10px 6px;
    }
}
</style>